var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CFTitle',{attrs:{"title":"25. Buget - Plan anual de cheltuieli"}}),_c('div',{staticClass:"table-margin"},[_c('b-table',{attrs:{"responsive":"","fields":_vm.fields,"items":_vm.items,"thead-class":"blue-head"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }